'use client';

import { useState, useEffect } from 'react';


interface AlertNotificationBadgeProps {
  count?: number;
  priority?: 'low' | 'medium' | 'high' | 'urgent';
  className?: string;
  showPulse?: boolean;
}

const AlertNotificationBadge = ({
  count = 0,
  priority = 'medium',
  className = '',
  showPulse = false,
}: AlertNotificationBadgeProps) => {
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (count > 0) {
      setIsAnimating(true);
      const timer = setTimeout(() => setIsAnimating(false), 300);
      return () => clearTimeout(timer);
    }
  }, [count]);

  if (count === 0) return null;

  const getPriorityStyles = () => {
    switch (priority) {
      case 'urgent':
        return 'bg-error text-error-foreground';
      case 'high':
        return 'bg-warning text-warning-foreground';
      case 'medium':
        return 'bg-accent text-accent-foreground';
      case 'low':
        return 'bg-primary text-primary-foreground';
      default:
        return 'bg-accent text-accent-foreground';
    }
  };

  return (
    <span
      className={`inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full text-xs font-medium font-caption transition-smooth ${getPriorityStyles()} ${
        isAnimating ? 'animate-scale-in' : ''
      } ${showPulse ? 'animate-pulse-gentle' : ''} ${className}`}
    >
      {count > 99 ? '99+' : count}
    </span>
  );
};

export default AlertNotificationBadge;